

export function downloadFile(fileName: string, mimeType: string, data: BlobPart) {
    const blob = new Blob([data], { type: mimeType });
    const downloadLinkEl = document.createElement('a');
    downloadLinkEl.href = window.URL.createObjectURL(blob);
    downloadLinkEl.download = fileName;
    downloadLinkEl.rel = 'noopener noreferrer';
    downloadLinkEl.click();
}

export function downloadFileByByteArr(fileName: string, mimeType: string, data: any[]) {
    const downloadLinkEl = document.createElement('a');
    downloadLinkEl.href = `data:${mimeType};base64,${data}`;
    downloadLinkEl.download = fileName;
    downloadLinkEl.rel = 'noopener noreferrer';
    downloadLinkEl.click();
}

export function downloadFileByUrl(url: string) {
    const downloadLinkEl = document.createElement('a');
    downloadLinkEl.href = url;
    downloadLinkEl.target = '_blank';
    downloadLinkEl.rel = 'noopener noreferrer';
    downloadLinkEl.click();
}
